module.exports = __webpack_public_path__ + "img/stock-front.0e1c8bb3.jpeg";